import { RulesConditionsSymbols } from "@/models/business-rules/RulesConditionsSymbols";

export const conditionsSymbols: RulesConditionsSymbols[] = [
  { filter: "lt", value: "less than" },
  { filter: "lte", value: "less than or equals" },
  { filter: "eq", value: "equal to" },
  { filter: "gt", value: "greater than" },
  { filter: "gte", value: "greater than or equals" }
];
